// extracted by mini-css-extract-plugin
export default {"btn":"ConfirmedReservationsRow_btn__NyJY2","table-number-cell":"ConfirmedReservationsRow_table-number-cell__uZR-X","tr":"ConfirmedReservationsRow_tr__aguPT"};